export default __webpack_public_path__ + "static/media/cake.dccae477.jpg";